import { Outlet } from 'react-router-dom';
import styles from './AuthLayout.module.css';

export function AuthLayout() {
  return (
    <div className={styles.container}>
      <div className={styles.background} />
      <main className={styles.main}>
        <Outlet />
      </main>
    </div>
  );
}
